import { render, staticRenderFns } from "./ErrorHistory.vue?vue&type=template&id=a66e2c20&"
import script from "./ErrorReport.js?vue&type=script&lang=js&"
export * from "./ErrorReport.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports